var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 14V10H18.706C18.567 9.535 18.386 9.089 18.158 8.67L19.778 7.05L16.95 4.222L15.33 5.842C14.911 5.615 14.465 5.432 14 5.294V3H10V5.294C9.535 5.432 9.089 5.615 8.67 5.842L7.05 4.222L4.222 7.05L5.842 8.67C5.614 9.089 5.433 9.535 5.294 10H3V14H5.294C5.433 14.465 5.614 14.911 5.842 15.33L4.222 16.95L7.05 19.778L8.67 18.158C9.089 18.385 9.535 18.568 10 18.706V21H14V18.706C14.465 18.568 14.911 18.385 15.33 18.158L16.95 19.778L19.778 16.95L18.158 15.33C18.386 14.911 18.567 14.465 18.706 14H21Z",
    stroke: "#00B2A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12C15 13.657 13.657 15 12 15C10.343 15 9 13.657 9 12C9 10.343 10.343 9 12 9C13.657 9 15 10.343 15 12Z",
    stroke: "#00B2A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/Gear.71f3b1ce377db051923d1cceddd20c8e.svg";
export { ForwardRef as ReactComponent };